module.exports = __webpack_public_path__ + "media/images/groupRank__eval--wrong@3x-0a519cbf0fbdb333aaaea2ed41149ab4.png";